import {Compartment, type Extension} from '@codemirror/state'
import type {EditorView} from '@codemirror/view'
import {useEffect, useMemo} from 'react'

/**
 * Create a new `Compartment` around this extension so that it can be reconfigured without replacing the entire editor
 * state. For more info see: https://thetrevorharmon.com/blog/codemirror-and-react/#updating-an-extension-based-on-react-state
 * @param view The editor view instance, for dispatching updates.
 * @param extension The extension to track. Must be memoized. On changes, an editor state update will be dispatched.
 * @returns A constant reference to a new `Extension` that contains the created compartment.
 */
export function useCompartment(view: EditorView | null, extension: Extension) {
  const compartment = useMemo(() => new Compartment(), [])

  useEffect(() => view?.dispatch({effects: compartment.reconfigure(extension)}), [view, extension, compartment])

  return useMemo(() => compartment.of([]), [compartment])
}
